<template>
  <div class="form__sidepanel">
    <OfferInformation
      v-if="currentPageIndex > 0"
      class="hide--mobile"
      style="margin-bottom: 2.1rem"
    ></OfferInformation>
    <ProductionInformation></ProductionInformation>
  </div>
</template>

<script>
import store from '../store';

import OfferInformation from './OfferInformation';
import ProductionInformation from './ProductionInformation';

export default {
  name: 'Sidepanel',
  components: {
    OfferInformation,
    ProductionInformation,
  },
  computed: {
    currentPageIndex() {
      return store.state.currentPageIndex;
    },
    panel() {
      return store.state.panelsVal;
    },
  },
};
</script>

<style>
.form__sidepanel {
  height: fit-content;
  border-radius: 0rem;
  margin-right: 2em;
  padding: 2rem;
  width: 40% !important;
}

@media (max-width: 47.99em) {
  .form__sidepanel {
    position: fixed;
    bottom: 5rem;
    left: 1rem;
    right: 1rem;
    min-width: unset !important;
    width: unset !important;
    margin: 0;
    padding: 1rem;
  }
}
</style>
